import { createContext } from "react";

export const MapContext = createContext<google.maps.Map | null>(null);
MapContext.displayName = "MapContext";
